export type UserLocationSearchField = 'country' | 'province'

interface ResolveUserListQueryOptions {
	allowedSearchFields: string[]
	defaultSearchField: string
	allowedStatuses?: string[]
}

export const buildUsersLocationFilterPath = (
	field: UserLocationSearchField,
	value: string,
) => {
	const searchParams = new URLSearchParams({
		page: '1',
		limit: '10',
		search_field: field,
		search_key: value,
		status: 'Active',
	})

	return `/users?${searchParams.toString()}`
}

/** Opens the location-scoped User list without navigating to the main User section. */
export const buildLocationUsersPagePath = (
	field: UserLocationSearchField,
	value: string,
) => {
	const searchParams = new URLSearchParams({
		page: '1',
		limit: '10',
		search_field: field,
		search_key: value,
		status: 'Active',
	})

	return `/${field}/${encodeURIComponent(value)}/users?${searchParams.toString()}`
}

export const resolveUserListQuery = (
	searchParams: URLSearchParams,
	{
		allowedSearchFields,
		defaultSearchField,
		allowedStatuses = [],
	}: ResolveUserListQueryOptions,
) => {
	const searchFieldFromUrl = searchParams.get('search_field')
	const statusFromUrl = searchParams.get('status') || 'All'
	const pageFromUrl = Number(searchParams.get('page'))
	const limitFromUrl = Number(searchParams.get('limit'))

	return {
		searchField:
			searchFieldFromUrl &&
			allowedSearchFields.includes(searchFieldFromUrl)
				? searchFieldFromUrl
				: defaultSearchField,
		searchValue:
			searchParams.get('search_key') ||
			searchParams.get('search') ||
			null,
		status: allowedStatuses.includes(statusFromUrl)
			? statusFromUrl
			: 'All',
		page:
			Number.isInteger(pageFromUrl) && pageFromUrl > 0 ? pageFromUrl : 1,
		limit:
			Number.isInteger(limitFromUrl) && limitFromUrl > 0
				? limitFromUrl
				: 10,
	}
}
